import { useState } from 'react'
import Navbar from '../../components/navbar/Navbar'
import Footer from '../footer/Footer'
import {Link} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import './paysection.css'
import { useEffect } from "react";
import {
    PayPalScriptProvider,
    PayPalButtons,
    usePayPalScriptReducer
} from "@paypal/react-paypal-js";

function PaySection() {
    const[cash, setCash] = useState(false);
    const dispatch = useDispatch()
    const cart = useSelector(state => state.cart)
    console.log(cart.cost)
    // This values are the props in the UI
    const amount = cart.total;
    const currency = "USD";
    const style = {"layout":"vertical"};

    const ButtonWrapper = ({ currency, showSpinner }) => {
    // usePayPalScriptReducer can be use only inside children of PayPalScriptProviders
    // This is the main reason to wrap the PayPalButtons in a new component
    const [{ options, isPending }, dispatch] = usePayPalScriptReducer();

    useEffect(() => {
        dispatch({
            type: "resetOptions",
            value: {
                ...options,
                currency: currency,
            },
        });
    }, [currency, showSpinner]);


    return (<>
            { (showSpinner && isPending) && <div className="spinner" /> }
            <PayPalButtons
                style={style}
                disabled={false}
                forceReRender={[amount, currency, style]}
                fundingSource={undefined}
                createOrder={(data, actions) => {
                    return actions.order
                        .create({
                            purchase_units: [
                                {
                                    amount: {
                                        currency_code: currency,
                                        value: amount,
                                    },
                                },
                            ],
                        })
                        .then((orderId) => {
                            // Your code here after create the order
                            return orderId;
                        });
                }}
                onApprove={function (data, actions) {
                    return actions.order.capture().then(function (details) {
                       console.log(details)
                    });
                }}
            />
        </>
    );
}

    
    

    const handleSubmit = (e) =>{
     e.preventDefault();
     setCash(false);
    }
    return (
        <div className='paysection'>
        <Navbar/>
        <div className='payWrapper'>
    <Link to='/' className='link'><button className='back--btn'>Back</button></Link>    
            <div className='payLeft'>
                <table>
                    <thead>
                        <tr className='table--title'>
                            <th>House</th>
                            <th>Name</th>
                            <th>ID</th>
                            <th>Phone</th>
                            <th>Date</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                    {cart.products.map((p) => (
                        <tr className='table--data'>
                            <td><img className='tableImg' src={p.img} alt=''/></td>
                            <td>{p.name}</td>
                            <td>{p.id}</td>
                            <td>{p.phone}</td>
                            <td>{p.date}</td>
                            <td><b>{`$ ${p.cost}`}</b></td>
                        </tr>
                    ))}
                        
                       
                    </tbody>
                </table>
            </div>
            <div className='payRight'>
            <div className='payRight--wrapper'>
                <h1><span>Pay</span> Rent & Desposit here</h1>
                <p><b>Amount:</b> ${cart.total}</p>
                <p><b>Tax:</b> 0(Zero rated)</p>
                <p><b>Total:</b> ${cart.total}</p>
                <button className='cash--btn' onClick={() => setCash(true)}>Pay on cash on deliverly</button>
                 <PayPalScriptProvider
                options={{
                    "client-id": "AT7zG0UfURvyiUbu80pD4Pl44HeaAwJyzYfG7KbADk3xY4RqhTbA8v5-MUa3v6LIrYEhRCElYlUn9ETo",
                    components: "buttons",
                    currency: "USD",
                    "disable-funding":"credit,card,p24"
                }}
            >
				<ButtonWrapper
                    currency={currency}
                    showSpinner={false}
                />
			</PayPalScriptProvider>
                </div>
            </div>
            </div>
            {cash && (
           <div className="cash--pay--modal">
                <form className='pay--form' onSubmit={handleSubmit}>
                <i className='fas fa-close' onClick={() => setCash(false)}></i>
                    <input type='text' placeholder='name' required/>
                    <input type='text' placeholder='Phone' required/>
                    <input type='text' placeholder='Addrress' required/>
                    <input type='email' placeholder='Email' required/>
                    <input type='text' placeholder='Amount' required/>
                    <button type='submit'>Pay</button>
                </form>
             </div>
            )}
           
               <Footer/>
        </div>
    )
}

export default PaySection
